// Import model
import { CreateSelectionBinRequest } from '../models/CreateSelectionBinRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CreateRoomSelectionRequest } from '../models/CreateRoomSelectionRequest';

// Import dependency serializers (for complex types)
import { CreateRoomSelectionRequestSerializer } from './CreateRoomSelectionRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CreateSelectionBinRequest - handles JSON serialization and deserialization with type validation
 */
export class CreateSelectionBinRequestSerializer {
  /**
   * Deserializes a JSON string into a CreateSelectionBinRequest instance
   */
  static deserialize(json: string): CreateSelectionBinRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CreateSelectionBinRequest instance
   */
  static fromObject(obj: any): CreateSelectionBinRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CreateSelectionBinRequest');
    }


    const instance: CreateSelectionBinRequest = {
      description: obj['description'] as string | undefined,
      itemIds: obj['itemIds'] ? (obj['itemIds'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
      name: obj['name'] as string,
      roomSelection: CreateRoomSelectionRequestSerializer.fromObject(obj['roomSelection']),
      rooms: obj['rooms'] ? (obj['rooms'] as any[]).map((item: any) =>
        item as string
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CreateSelectionBinRequest instances
   */
  static deserializeArray(json: string): CreateSelectionBinRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CreateSelectionBinRequest instance to a JSON string
   */
  static serialize(instance: CreateSelectionBinRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CreateSelectionBinRequest instance to a plain object
   */
  static toObject(instance: CreateSelectionBinRequest): any {
    return {
      'description': instance.description,
      'itemIds': instance.itemIds?.map((item: any) =>
        item
      ),
      'name': instance.name,
      'roomSelection': instance.roomSelection ? CreateRoomSelectionRequestSerializer.toObject(instance.roomSelection) : undefined,
      'rooms': instance.rooms?.map((item: any) =>
        item
      ),
    };
  }

  /**
   * Serializes an array of CreateSelectionBinRequest instances to a JSON string
   */
  static serializeArray(instances: CreateSelectionBinRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
